import React, { useEffect, useState } from "react";
import { setIsSkipSurveyForFirstTimeSOToMediator } from "../../../reducers/silentObserver-reducer";
import PropTypes from "prop-types";

import BrandingDetailScreen from "./BrandingDetailScreen/BrandingDetailScreen";
import { CONNECTING_SCREEN } from "../../../constants/Constants";
import EnterSessionIDForm from "./EnterSessionIDForm/EnterSessionIDForm";
import EnterGuestName from "./EnterGuestName/EnterGuestName";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import Survey from "./Survey/Survey";
import { useSelector, useDispatch } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";
import { surveyRedirection } from "../../../shared/utility";
import { SURVEY_TYPE } from "../../../constants/SurveyConstants";
import navigatorService from "../../../services/navigatorService";

const ConnectingScreen = ({ handleToShowPrivacyPolicyPopup, changeConnectingScreenStep, localisedValuesForCallBody }) => {
    const ldFlags = useFlags();
    const dispatch = useDispatch();

    const { privacyPolicyError, isCompanyAvailableError } = useSelector((state) => state.onLoadData);
    const { joinMeetingError } = useSelector((state) => state.joinMeeting);
    const { isCallDisconnected, showCallDisconnectedPopup } = useSelector((state) => state.commonReducer);
    const { isSkipSurveyForFirstTimeSOToMediator } = useSelector((state) => state.silentObserver);

    const [showSurvey, setShowSurvey] = useState(false);
    const [privacyPolicyDataErrorMsg, setPrivacyPolicyDataErrorMsg] = useState("");

    /* Handle to show error message based on privacy and iscompany api failed */
    useEffect(() => {
        const errorMessage =
            isCompanyAvailableError?.message ||
            privacyPolicyError?.message ||
            (joinMeetingError?.message === "Network Error"
                ? localisedValuesForCallBody.unable_to_join_call_please_try_after_sometime
                : joinMeetingError?.message);
        setPrivacyPolicyDataErrorMsg(errorMessage);
    }, [privacyPolicyError, isCompanyAvailableError, joinMeetingError]);

    useEffect(() => {
        if (!showCallDisconnectedPopup) {
            const checkForRegularMeet = isCallDisconnected && CALL_DATA.callDuration > 0 && !isSkipSurveyForFirstTimeSOToMediator;
            const checkForUploadOnlyMeet = PublicVariables.isOnlyUploadImageMeet && !showCallDisconnectedPopup;
            if (checkForRegularMeet || checkForUploadOnlyMeet) {
                checkForShowSurvey();
            }
            if (isSkipSurveyForFirstTimeSOToMediator) {
                dispatch(setIsSkipSurveyForFirstTimeSOToMediator(false));
            }

            CALL_DATA.callDuration = 0;
        }
    }, [isCallDisconnected, showCallDisconnectedPopup]);

    const checkForShowSurvey = () => {
        setShowSurvey(false);
        if (ldFlags?.surveyMonkey && GLOBAL_MEETING_DATA.survey?.openSurvey) {
            if (GLOBAL_MEETING_DATA.survey.surveyType === SURVEY_TYPE.STANDARD) {
                setShowSurvey(true);
            }

            if (
                GLOBAL_MEETING_DATA.survey.surveyType === SURVEY_TYPE.SURVEYMONKEY ||
                GLOBAL_MEETING_DATA.survey.surveyType === SURVEY_TYPE.CUSTOMLINK
            ) {
                if (navigatorService.isMobileDevice()) {
                    surveyRedirection();
                } else {
                    setShowSurvey(true);
                }
            }
        }
    };

    return (
        <div className='call-connection custom-scroll' data-testid='connectionScreen'>
            {/* connecting & disconnect screen */}
            {changeConnectingScreenStep === CONNECTING_SCREEN.ENTER_SESSIONID_SCREEN && (
                <div className='call-connection-in'>
                    {PublicVariables.isOnlyUploadImageMeet && isCallDisconnected && (
                        <div className='finish-upload-text'>{localisedValuesForCallBody.finished_uploading}</div>
                    )}
                    <BrandingDetailScreen />

                    <EnterSessionIDForm handleToShowPrivacyPolicyPopup={handleToShowPrivacyPolicyPopup} />

                    {/* Enable this Survey once setup done */}
                    {showSurvey && <Survey />}

                    {privacyPolicyDataErrorMsg && <div className='validation-error session-id-error'>{privacyPolicyDataErrorMsg}</div>}
                </div>
            )}

            {/* Enter guest name */}
            {changeConnectingScreenStep === CONNECTING_SCREEN.ENTER_GUESTNAME_SCREEN && (
                <EnterGuestName privacyPolicyDataErrorMsg={privacyPolicyDataErrorMsg} />
            )}
        </div>
    );
};

ConnectingScreen.propTypes = {
    handleToShowPrivacyPolicyPopup: PropTypes.func,
    changeConnectingScreenStep: PropTypes.string,
    localisedValuesForCallBody: PropTypes.object,
};

export default ConnectingScreen;
